import { render } from "./Kategori.vue?vue&type=template&id=5fcf327a"
import script from "./Kategori.vue?vue&type=script&lang=js"
export * from "./Kategori.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__